import AiTestPage from './AiTest';

export default AiTestPage;

